import Panolens from './Panolens';

const TWEEN = Panolens.TWEEN;
const PANOLENS = Panolens.PANOLENS;
import * as $ from 'jquery';
import * as _ from 'underscore';
import {PanotestComponent} from './panotest.component';
import MyClass from './MyClass';
import UserInterface from './UserInterface';
import * as THREE from 'three';
import {PanotestService} from './panotest.service';
import './models';

//-------------------------------------------------------------------------
//
// Builds scenes using widgets and other elements
//
//

export default class Scenes {


  sceneId: number = 0;
  highestScene: number = 0;
  lastScene: Scene;
  currentScene: Scene;
  helpIdx: number = 0;
  ui: UserInterface;
  pano: PanotestComponent;
  game: MyClass;
  panoservice: PanotestService;


  constructor(panoservice: PanotestService) {
    this.panoservice = panoservice;
    this.game = panoservice.game;
    this.pano = panoservice.scope;
    this.ui   = panoservice.ui;

  }

  setId() {
    //this can be delayed so ui doesnt appear instantly. Maybe this should be done via CSS animations or fades
    console.log('Update Scene ID');
    this.sceneId = this.currentScene.id;
  }


  clearLinkedSpots() {
    console.log('************** RESET *****************')
    //if(this.currentScene) this.currentScene.pano.linkedSpots = [];
    //if(this.currentScene && this.currentScene.widgetStore) this.currentScene.widgetStore=[];
    //if(this.currentScene) this.currentScene.pano.children=[];
    if (this.currentScene) {
      _.each(this.currentScene.pano.children, function (item) {
        console.log(item);
      });


    }
  }

  hideSpotById(spotName: string) {
    let spots = this.panoservice.scope.viewer.getChildren();
    if (spots) {
      _.each(spots, function (s: any, i) {

        if (s.name == spotName) {
          console.log('HIDE SPOT');
          this.disableSpot(s);
        }
      }, this)
    }
  }

  showSpotbyId(spotName: string) {
    let spots = this.panoservice.scope.viewer.getChildren();
    if (spots) {
      _.each(spots, function (s: any, i) {

        if (s.name == spotName) {
          this.enableSpot(s);
        }
      }, this);
    }
  }

  refreshSpots() {
    _.each(this.currentScene.widgets, function (w: Link) {
      if (w.active) {
        this.showSpotById(w.id)
      } else {
        this.hideSpotById(w.id)
      }

    }, this)
  }

  disableSpot(spot: any) {
    spot.userData.hidden = true;   //used in PanolensJs to bug out rendering the hover text
    spot.layers.mask = 0;           //prevents rendering in the viewer
  }

  enableSpot(spot: any) {

    spot.userData.hidden = false;   //used in PanolensJs to bug out rendering the hover text
    spot.layers.mask = 1;           //prevents rendering in the viewer
    //any animation..


  }

  enableWidget(spotName: string) {
    console.log('SCENES: enableWidget ' + spotName)
    //find in data
    const spotData: Link = _.find(this.currentScene.widgets, function (elem) {

      return (elem.link.id == spotName || elem.link.name == spotName);

    });

    if (spotData) {
      console.log('WIDGET DATA SET ACTIVE ', spotData);
      spotData.active = true;
      this.showSpotbyId(spotName);


    }


  }

  linkToMapInteraction(obj){

    const targetScene: any = _.findWhere(this.panoservice.scope.scene, {id: obj.targetLoc});
    let i: Action = obj;

    if(i) {

      return {
        img: this.panoservice.ui.toolbar.map,
        type: 'location',
        index: obj.index || null,
        text: obj.label || i.label,
        active: obj.active || i.active,
        link: {
          pano: targetScene.pano || i.pano,
          coords: obj.coords || i.coords,
          size: 200,
          img: this.panoservice.ui.icons.map,
          name: obj.name || i.infoSpotId
        }};



    }else{
      console.log('CHECK Action references. ACTION not found TOPIC:'+obj.topic+" ID:"+obj.id)
    }
  }


  linkToInteraction(obj){

    //let i: Action = _.findWhere(this.game.getTopic(obj.topic).interactions, {id: obj.id});
    let i: Action = obj;

    if (i) {
      let icon: string = '';
      let iconWidget: string = '';
      let coords: any = i.coords || obj.coords

      if(i.tipIcon =='read') {icon = this.panoservice.ui.toolbar.read; iconWidget = this.panoservice.ui.icons.read}
      if(i.tipIcon =='video') {icon = this.panoservice.ui.toolbar.video; iconWidget = this.panoservice.ui.icons.video}
      if(i.tipIcon =='listen') {icon = this.panoservice.ui.toolbar.listen; iconWidget = this.panoservice.ui.icons.listen}
      if(i.tipIcon =='quiz') {icon = this.panoservice.ui.toolbar.quiz; iconWidget = this.panoservice.ui.icons.quiz}
      if(i.tipIcon =='map') {icon = this.panoservice.ui.toolbar.map; iconWidget = this.panoservice.ui.icons.map}
      if(i.tipIcon =='exit') {icon = this.panoservice.ui.toolbar.door; iconWidget = this.panoservice.ui.icons.door}


      return {
        img: icon,
        type: 'spot',
        index: i.iconOrder,
        text: i.label,
        active: i.active,
        link: {
          coords: coords,
          size: 350,
          img: iconWidget,
          id: i.infoSpotId,
          text: i.label,
          action: () => {
              this.panoservice.game.setCurrentInteraction(obj.id);  //Set this as current
              this.game.processClick(obj);
            }

          }
        };

    }else{
      console.log('Linked Interaction NOT FOUND ',obj.id);
      console.log('CHECK Action references. ACTION not found TOPIC:' + obj.topic + " ID:" + obj.id)
    }

  }


  linkToMap(text: string, index: number, active: boolean, pano: object, name: string, coords: object){
    return {
      img: this.panoservice.ui.toolbar.map,
      type: 'location',
      index: index,
      text: text,
      active: active,
      link: {
        pano: pano,
        coords: coords,
        size: 200,
        img: this.panoservice.ui.icons.map,
        name: name
      }};
  }

  linkToVideo(
    text: string,
    index: number,
    active: boolean,
    spot: string,
    interactionId: number,
    url: string,
    coords: object) {
    return {
      img: this.panoservice.ui.toolbar.video,
      type: 'spot',
      index: index,
      text: text,
      active: active,
      link: {
        coords: coords,
        size: 350,
        img: this.panoservice.ui.icons.video,
        id: spot,
        text: text,
        action: (function () {
          let f = function () {
            this.panoservice.game.setCurrentInteraction(interactionId);
            this.panoservice.ui.videoPlayerURL = url;
            this.panoservice.uishowVideoPlayer = true;
            window.setTimeout(this.panoservice.ui.setVideo, 500);
          }
          return f;
        })()
      }
    }
  }

  buildScene(scene = this.currentScene, force: boolean = false) {
    console.log(' ');
    console.log(' ');
    console.log('============BUILD SCENE===========',scene);
    this.panoservice.ui.clearWidgets();         //clear old widgets

    $('#sceneInfo').hide();
    //this.clearLinkedSpots();

    const panoWidgets = this.game.getPanoActivitiesByScene(scene.id);  //get a list of actvities that need infospots

    const t = this;
    scene.widgets = [];

    _.each(panoWidgets, function(a,idx){
      if(a!=undefined) {
        console.log('Build Scene Widget:'+a.id+' '+a.desc)
        if (a.hasOwnProperty('targetLoc')) {
          //we have a location
          scene.widgets.push(this.linkToMapInteraction(a));
        } else {
          scene.widgets.push(this.linkToInteraction(a));
        }
      }else{
        //
      }

    }, this)

    this.build(scene, force);  //each pano has the scene object attached.
    this.highestScene = (scene.id > this.highestScene) ? scene.id : this.highestScene;

  }


  build(scene: Scene = this.currentScene, force: boolean = false) {
    //Usually called on onLoad event
    if (!scene){
      console.log('ERROR NO SCENE PASSED');
      return
    }

    this.lastScene = (this.currentScene) ? this.currentScene : null;
    this.currentScene = scene;
    //if(this.lastScene = this.ui.SCOPE.menu) scene.built = false;
    this.currentScene.widgetStore = [];
    scene.built = false;

    if(this.currentScene.pano && this.currentScene.pano.children) this.currentScene.pano.children = [];


    this.panoservice.ui.widgets = [];

    if (!scene.built || force) {
      console.log('-------------BUILD WIDGETS-------------');
      this.buildWidgets(scene, this.game.topic);
      //this.buildEvents(scene);
      this.panoservice.ui.bigLabel.text = this.currentScene.title;
      this.panoservice.ui.bigLabel.desc = this.currentScene.desc;
      scene.built = true;
      this.addWidgetsToView();


    } else {
      console.log('-------------BUILT ALREADY-------------');

      this.panoservice.ui.bigLabel.text = this.currentScene.title;
      this.panoservice.ui.bigLabel.desc = this.currentScene.desc;
      this.addWidgetsToView(true);


    }

    this.sceneId = this.currentScene.id;


  }
  addWidgetsToView(from: boolean = false) {
    let noValidLastSceneId = false;
    let menuLookAt: any;

    //Copy widgets from scene and create them
    _.each(this.currentScene.widgetStore, function (w: any, idx) {
      //console.log(w);

      //if(w.topics && w.topics.indexOf(this.game.topic) == -1) return
      let e = this.pano.viewer.appendControlItem(w);
      e.title = ''+ w.helpText;
      e.addEventListener('click', function () {
          w.focusObj.focus();
        }
      );
      e.addEventListener('keyup', function (event: KeyboardEvent) {
          console.log('WIDGET KEYUP', event)
          if (event.keyCode == 13) {
            //Execute the spot
            console.log(w.focusObj);
            if(w.focusObj.clickHandler){
              w.focusObj.clickHandler();
            }else{
              if(w.focusObj){
                w.focusObj.doClick();

              }
            }
          }
        }
      );

      this.panoservice.ui.widgets.push(e);

      //we are building a scene and coming from this lastscene.id
      if (from) {
        if(w.fromPano == 0) menuLookAt = w.focusObj;  //store this
        if (w.fromPano == this.lastScene.id) {
          this.panoservice.ui.lookAtTarget = w.focusObj;  //Set this for the camera to look at
        }else{
          noValidLastSceneId = true;
          this.panoservice.ui.lookAtTarget = w.focusObj; //default to anything

        }
      }

    }, this);

    //Finally. If we can't look from a direction when entering the scene
    //use the default menu look at coords.

    if (noValidLastSceneId) {this.panoservice.ui.lookAtTarget = menuLookAt;}



  }
  buildWidgets(scene, topic) {
    let pin;
    console.log('Build Widgets and map pins TOPIC:' + this.game.topic);
    console.log('Found ' + scene.widgets.length + ' widgets');
    _.each(scene.widgets, function (elem: Link, idx, list) {

      if (elem.topics && elem.topics.indexOf(this.panoservice.game.topic) == -1) return

      if (elem.type === 'location') {
        //Location

        let spot = scene.pano.link(elem.link.pano, new THREE.Vector3(elem.link.coords.x, elem.link.coords.y, elem.link.coords.z), elem.link.size, elem.link.img, elem);
        //spot.addHoverText(elem.text);
        //div.innerHTML = '<div class="test">TEST</div>'
        //spot.addInfoElement(div);

        let pin = elem.obj = scene.pano.linkedSpots[scene.pano.linkedSpots.length - 1];
        elem.obj.name = elem.link.name;
        elem.text = elem.text;
        //imgSrc, focusObj, idx, txt, fromId = 0, helper = false, completed = false, active = true
        elem.widget = this.createWidget({ imgSrc: elem.img, focusObj: pin, idx: elem.index, txt: elem.text, fromid: 0, helper: false, completed: false, active: elem.active});

        if (elem && !elem.active) {
          if (elem.active == false) {

            elem.obj.layers.mask = 0;
            elem.obj.userData.hidden = true;
          }
        } else {
          elem.obj.userData.hidden = false;
        }


      } else {
        //InfoSpot
        let spot = this.buildSpot(
          scene.pano,
          {x: elem.link.coords.x, y: elem.link.coords.y, z: elem.link.coords.z},
          elem.link.size,
          elem.link.img,
          elem.link.id,
          elem.link.text,
          elem);

        elem.obj = spot;
        let isCompleted = false;
        if (elem.link.id) {
          const l = this.game.getActivityByInfoSpot(this.panoservice.game.topic, elem.link.id)
          isCompleted = l.completed;
        }


        elem.widget = this.createWidget({imgSrc: elem.img, focusObj: spot, id: elem.link.id, idx: idx, txt: elem.link.text, active: elem.active, completed: isCompleted, helper: false });

      }


    }, this);


    //HELPER. To assist in looking in direction when entering a scene.
    if (this.lastScene) console.log('LAST SCENE ID: ' + this.lastScene.id);
    //As we can come from other location lets figure out which way to face via the helpers
    let s;
    let i;
    this.helpIdx = 0;
    let vaildLookAt = false;
    let menuLook;

    if (!scene.lookAtTarget) {
      return;
    }

    if (scene.lookAtTarget instanceof Array) {

      _.each(scene.lookAtTarget, (l: LookAtTarget) => {
        //Used during dev to place marker whre the camera looks
        s = this.buildHelper(scene, l);  //build helper object (onscreen infospot)

        if (l.from == 0) menuLook = s; //save the menu lookat if any

        if (l && this.lastScene && this.lastScene.id === l.from) {
          this.panoservice.ui.lookAtTarget = s;
          //console.log(s);
          vaildLookAt = true;
        }
      }, this);

      if(!vaildLookAt){
        //we dont have a valid lookat direction so try to use menu
        console.log('No valid lookup')
        let d = _.findWhere(scene.lookAtTarget,{from: 0});
        //console.log(d)
        if(d && menuLook){
          //console.log(s);
          this.panoservice.ui.lookAtTarget = menuLook;
        }
      }


    } else {

      s = this.buildHelper(scene, scene.lookAtTarget);

      this.panoservice.ui.lookAtTarget = s;

    }


  }
  buildSpot(scene: Scene, coords, scale, imgsrc, spotName, hoverText, elem?) {

    //console.log('Build InfoSpot', coords, scale, imgsrc, spotName, hoverText)
    let obj = new PANOLENS.Infospot(scale, imgsrc);
    obj.position.set(coords.x, coords.y, coords.z);
    obj.name = spotName;
    if(this.game.showHoverText==true) obj.addHoverText(hoverText);

    if (elem && elem.link.action) {
      obj.clickHandler = elem.link.action;
    }

    console.log(obj)
    scene.add(obj);

    if (elem && !elem.active) {
      if (elem.active == false) {

        obj.layers.mask = 0;
        obj.userData.hidden = true;
      }
    } else {
      obj.userData.hidden = false;
    }

    //console.log(elem);
    return obj;
  }

  buildHelper(scene, lookAt) {

    let spot1 = this.buildSpot(
      scene.pano,
      {x: lookAt.x, y: lookAt.y, z: lookAt.z},
      200,
      (this.panoservice.ui.debug) ? 'assets/images/mousearrows.png' : 'assets/images/emptypixel.png',
      'Helper',
      lookAt.desc);

    //Only use during development. Shows a cross hair to align camera look.
    this.createWidget({imgSrc:'assets/images/mobile-icon.png', focusObj: spot1, idx: 9 + this.helpIdx++, txt: lookAt.desc, fromId: lookAt.from, helper: true, isCompleted: false, active: true});


    return spot1;

  }
  createWidget(elem: any) {
    //Only creates the data object to build/render later
    //imgSrc, focusObj, idx, txt, fromId = 0, helper = false, completed = false, active = true
    //elem.img, spot, elem.index, elem.text, 0, false, isCompleted, elem.active
    console.log(elem);
    let tmp: any = {
      style: {
        backgroundImage: 'url(' + elem.imgSrc + ')',
        width: '20%',
        height: 'auto',
        //position: 'absolute',
        //left: 50%',
        //top: '-30px',
        id: 'widget' + elem.id,
        display: (elem.helper) ? 'none' : 'block',
        //opacity: (completed || !active)? 0.5 : 1
        //opacity: (completed) ? 1 : 0.5,
        minWidth: '40px',
        maxWidth: '40px'

      },
      focusObj: elem.focusObj,
      spotName: elem.focusObj.name,
      onTap: function (event) {
        //this.focusObj.focus();
      },
      helpText: elem.txt || '',
      id: elem.id,
      fromPano: elem.fromId,
      active: elem.active
    };

    if(this.panoservice.ui.debug && elem.helper) tmp.style.display = 'block';  //show helpers if in debug mode
    if (elem.completed) tmp.style.opacity = 1;


    this.currentScene.widgetStore.push(tmp);
    return tmp;

  }
  findWidgetBySpotId(spotName: string) {
    return _.find(this.currentScene.widgetStore, {spotName: spotName});
  }

  onFadeStart() {
    return (event) => {
      console.log('>>>>>>>>>>>onFadeStart');
      this.panoservice.scope.setupCamera(this.currentScene);  //setup any camera settings
      if (this.currentScene.fadeStart) {
        this.currentScene.fadeStart();
      }  //do any specifics
    }
  }


  onFadeEnd() {
      return (event) => {
        console.log('>>>>>>>>>>>>onFadeEnd' , this.currentScene);
        if (this.currentScene.fadeStart) {
          this.currentScene.fadeComplete();
        }  //do any specifics
        this.panoservice.game.enterScene(this.currentScene);  //Process Scene
        this.panoservice.ui.hideBlocker();
      }
  }


  buildEvents(scene) {
    console.log('BUILD EVENTS FOR', scene);
    scene.addEventListener('enter-fade-start', this.onFadeStart);
    scene.pano.addEventListener('enter-fade-complete', this.onFadeEnd);

  }

  intersects(intersects) {

    _.each(intersects, function (elem: any) {
      console.log(elem);
      if (elem.object.type == 'Mesh') {
        elem.object.material.color.set(0xff0000);
        if (this.pano.currentObj) {
          let obj = this.panoservice.ui.hoverObject;
          console.log(elem.point);
          //obj.position.set(elem.point.x, elem.point.y, elem.point.z );
        }
      }
    });

  }


};
